/* eslint-disable react/react-in-jsx-scope */
import React, { useEffect } from "react";
import "./App.scss";
import Routes from "./routes/routes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tippy/dist/tippy.css";
import secureStorage from "./config/encrypt";
import { setEntitySourceBasedOnDomain } from "./view/common/Helper";

function App() {

	useEffect(() => {
		setEntitySourceBasedOnDomain()
		const onLogout = (event) => {
			if (event?.key === '3dbb4af3c5c4487908ea5f23315a2b578c09c5b20be208917b17e08a52c51e3f' || event?.key === 'logged_out') {
				// Perform logout actions in this tab
				// secureStorage.removeItem("authUserInfo");
				// secureStorage.removeItem("userAccess");
				// window.location.href = '/login'; // Or update state
			}
		};

		window.addEventListener('storage', onLogout);

		return () => {
			window.removeEventListener('storage', onLogout);
		};
	}, []);

	return (
		<div className="App">
			<ToastContainer position={"top-right"} />
			<Routes />
		</div>
	);
}
export default App;
